import { useEffect, useState } from 'react';
import { useUI } from '@/context/UIContext';
import { SmallCheck } from '@/components/ui/Icons';

/** The confirmation bar that drops in after adding to the cart. */
export function Toast() {
  const { toast, hideToast } = useUI();
  const [on, setOn] = useState(false);

  useEffect(() => {
    if (!toast) return;
    setOn(false);
    const raf = requestAnimationFrame(() => requestAnimationFrame(() => setOn(true)));
    const t = window.setTimeout(() => setOn(false), toast.tone === 'error' ? 6000 : 4200);
    return () => { cancelAnimationFrame(raf); window.clearTimeout(t); };
  }, [toast]);

  return (
    <div className={'toast' + (on ? ' on' : '') + (toast?.tone === 'error' ? ' err' : '')} role="status" aria-live="polite">
      {toast && (
        <>
          <span className="ck">{toast.tone === 'error' ? '!' : <SmallCheck />}</span>
          <span className="msg">{toast.message}</span>
          {toast.action && (
            <button className="viewcart" onClick={() => { setOn(false); hideToast(); toast.action!.onClick(); }}>
              {toast.action.label}
            </button>
          )}
        </>
      )}
    </div>
  );
}
